<template>
  <div class="row">
    <div class="col-12">
      <template v-if="!typesDepenses">
        <div class="loading loading--mini">
          <div class="loading__loader">
            <inline-svg src="/images/icones/icon_loader.svg" />
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="typesDepenses.length > 0">
          <h2 class="h--headingM">Quelle est la nature du soin ? <span class="asterix">*</span></h2>
          <div class="nature__blocs" role="group">
            <button
              v-for="(typeDepense, index) in typesDepenses"
              :key="index"
              type="button"
              class="nature__bloc coloredButton"
              :class="typeDepenseStore === index ? '--active' : ''"
              @click="onTypeDepenseChange(index)"
            >
              <inline-svg :src="'/images/icones/' + bibliothequeImg[index] + '.svg'" />
              {{ typeDepense.name }}
            </button>
          </div>
        </template>
        <template v-else>
          Aucun type de dépense n'a été trouvé avec la combinaison du code client ({{ clientCode }}) et du régime sélectionné ({{ typeRegime }})
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import simulateurService from "@/services/simulateurService";
import { mapTypeSoin, pushSimulationEvent } from "@/helpers/matomo";
import { normalizeRouteContext } from "@/helpers/entrySource";

export default {
  name: "EtapeNature",
  components: {},
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    const routeContext = normalizeRouteContext(this.$route.params);

    return {
      // Données de l'URL
      clientCode: this.$route.params.clientCode,
      sourceEntree: routeContext.sourceEntree,
      typeRegime: routeContext.typeRegime,

      // Gestion des erreurs
      errorMessage: null,

      bibliothequeImg: ["icon_dentaire", "icon_optique", "icon_soin", "icon_hospitalier"],
      typesDepenses: null,
    };
  },
  computed: {
    typeDepenseStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/typeDepense"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateTypeDepense", value);
      },
    },
  },
  async mounted() {
    console.debug("Component Nature is mounted!");

    // Charger les données initiales
    await this.loadData();
  },
  methods: {
    async loadData() {
      try {
        // 1. Récupération des types de dépenses
        try {
          const depensesResponse = await simulateurService.getTypesDepenses(this.clientCode, this.typeRegime);
          this.typesDepenses = depensesResponse?.typesDepenses ?? depensesResponse ?? null;
          this.$store.dispatch("dataSimulateurStore/updateTypesDepenseAll", this.typesDepenses);
          this.typeCalcul = depensesResponse?.typeCalcul ?? null;

          if (!this.typesDepenses || this.typesDepenses.length === 0) {
            this.errorMessage = `Aucun type de dépense disponible pour cette combinaison de client (${this.clientCode}) et de régime (${this.typeRegime}).`;
            return;
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des types de dépenses:", error);
          this.errorMessage = `Erreur lors du chargement des types de dépenses: ${error.message || "Erreur inconnue"}`;
          return;
        }

        // 2. Récupération des types de remboursement
        try {
          this.typesRemboursement = await simulateurService.getTypesRemboursement(this.clientCode, this.typeRegime);
          if (!this.typesRemboursement || this.typesRemboursement.length === 0) {
            console.warn(`Aucun type de remboursement trouvé pour cette combinaison de client (${this.clientCode}) et de régime (${this.typeRegime}).`);
            this.typesRemboursement = [];
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des types de remboursement:", error);
          this.errorMessage = `Erreur lors du chargement des types de remboursement: ${error.message || "Erreur inconnue"}`;
          return;
        }
      } catch (error) {
        console.error("Erreur inattendue lors du chargement des données:", error);
        this.errorMessage = `Erreur inattendue: ${error.message || "Erreur inconnue"}`;
      }
    },
    onTypeDepenseChange(index) {
      const typeSoin = mapTypeSoin(index);

      pushSimulationEvent({
        event: "choix_type_soin",
        action: "choix_type_soin",
        label: typeSoin,
        payload: {
          type_soin: typeSoin,
        },
      });

      this.$store.commit("dataSimulateurStore/RESET_STATE");
      this.typeDepenseStore = index;
    },
  },
};
</script>
